export class GrowthApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Create a DRAFT campaign. */
    createCampaign(input) {
        return this.client.request({ method: 'POST', path: '/v1/growth/campaigns', body: input, auth: true });
    }
    /** The operator campaign list — every kind (or one `kind`), most recently updated first. */
    listCampaigns(kind) {
        const qs = kind !== undefined ? `?kind=${encodeURIComponent(kind)}` : '';
        return this.client.request({ method: 'GET', path: `/v1/growth/campaigns${qs}`, auth: true });
    }
    /** Read a campaign snapshot + its current revision. */
    getCampaign(campaignId) {
        return this.client.request({ method: 'GET', path: `/v1/growth/campaigns/${encodeURIComponent(campaignId)}`, auth: true });
    }
    /** Walk a lifecycle edge (DRAFT→ACTIVE→PAUSED⇄ACTIVE→ENDED). */
    transitionCampaign(campaignId, to) {
        return this.client.request({ method: 'POST', path: `/v1/growth/campaigns/${encodeURIComponent(campaignId)}/transition`, body: { to }, auth: true });
    }
    /** Hit the instant kill switch (terminal). */
    killCampaign(campaignId, reason) {
        return this.client.request({ method: 'POST', path: `/v1/growth/campaigns/${encodeURIComponent(campaignId)}/kill`, body: { reason }, auth: true });
    }
    /** Issue a grant against a campaign. */
    issueGrant(campaignId, input) {
        return this.client.request({ method: 'POST', path: `/v1/growth/campaigns/${encodeURIComponent(campaignId)}/grants`, body: input, auth: true });
    }
    /** List a campaign's grants (newest first). */
    listGrants(campaignId) {
        return this.client.request({ method: 'GET', path: `/v1/growth/campaigns/${encodeURIComponent(campaignId)}/grants`, auth: true });
    }
    /** Reverse a grant (fraud/chargeback clawback). `releaseAmount` is the budget to release. */
    reverseGrant(grantId, reason) {
        return this.client.request({ method: 'POST', path: `/v1/growth/grants/${encodeURIComponent(grantId)}/reverse`, body: { reason }, auth: true });
    }
}
//# sourceMappingURL=growth.js.map